var _style, _path, _path2, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabelNewFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 100",
    style: {
      enableBackground: "new 0 0 300 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8D4097;}\n\t.st1{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,100H20C9,100,0,91,0,80V20C0,9,9,0,20,0h260c11,0,20,9,20,20v60C300,91,291,100,280,100z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280,0H20C10.5,0,2.5,6.7,0.5,15.6v11.9c0,11,9,20,20,20h260c9.5,0,17.5-6.7,19.5-15.6V20C300,9,291,0,280,0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 58.8,
    cy: 46.3,
    r: 40.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.4,69.3c-2.9,0-8.1-0.2-10.8-0.7s-3.5-1.2-3.5-4.3V31.5c0-3,0.9-3.8,3.5-4.2c2.4-0.4,7.8-0.7,10.6-0.7 c11,0,18.2,2.6,18.2,12v1c0,3.5-1.8,6.6-4.3,8c2.5,1.5,4.5,4.5,4.5,8.1v0.7C158.7,67.2,149.4,69.3,140.4,69.3z M147.5,39.4 c0-2.2-1.3-3.6-5.7-3.6c-0.4,0-4,0.1-4.4,0.1v8h5.4c3.7,0,4.7-1.6,4.7-3.5V39.4z M147.7,55.5c0-2.2-1.2-4-4.9-4h-5.4V60h4.6 c4.4,0,5.8-1.6,5.8-4V55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.4,68.8h-7.8c-0.6,0-1.1-0.5-1.1-1.1v-1.2c-2.1,1.6-4.9,2.8-8,2.8c-4.4,0-9.6-2.5-9.6-10v-0.7 c0-6.7,5.1-9.1,14.4-9.1h2.4v-1.6c0-2.7-1.8-3.2-3.7-3.2c-3.6,0-7.1,0.1-9.7,0.4h-0.2c-0.6,0-1.1-0.4-1.1-1.1v-5.4 c0-0.6,0.4-1.1,1.1-1.3c1.8-0.6,6.7-1.3,10.2-1.3c8.1,0,14.1,2.9,14.1,12.1v19.8C190.5,68.3,190,68.8,189.4,68.8z M180.1,55.3h-2.7 c-2.8,0-3.9,0.9-3.9,3.2v0.6c0,1.9,1.3,2.5,2.9,2.5c1.3,0,2.9-0.4,3.8-0.8V55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.3,44.5h-0.8c-2.4,0-4.7,0.3-6.4,1.3v21.7c0,0.6-0.4,1.2-1.1,1.2h-8.4c-0.7,0-1.2-0.6-1.2-1.2V37.3 c0-0.6,0.5-1.1,1.1-1.1h8.1c0.6,0,1.1,0.5,1.1,1.1v1.3c2.5-2.6,4.5-2.9,6.9-2.9h0.6c0.6,0,1.1,0.5,1.1,1.1v6.6 C215.3,44,214.9,44.5,214.3,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.8,68.8H240c-0.6,0-1.1-0.5-1.1-1.1v-1.3c-2,1.5-4.7,2.9-8.8,2.9c-8.3,0-10.3-6.2-10.3-12.9v-19 c0-0.6,0.4-1.2,1.1-1.2h8.4c0.7,0,1.2,0.6,1.2,1.2v19c0,3,0.7,4,3.5,4c1.3,0,2.9-0.6,4.2-1.2V37.4c0-0.6,0.4-1.2,1.1-1.2h8.4 c0.7,0,1.2,0.6,1.2,1.2v30.2C248.9,68.3,248.4,68.8,247.8,68.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.8,37l-15-1.4l-6-13.8c-0.4-1-1.8-1-2.2,0l-6,13.8l-15,1.4c-1.1,0.1-1.5,1.4-0.7,2.1L47.3,49L44,63.8 c-0.2,1,0.9,1.8,1.8,1.3l13-7.7l13,7.7c0.9,0.5,2-0.3,1.8-1.3L70.2,49l11.3-9.9C82.3,38.4,81.9,37.1,80.8,37z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.4,21.3c0.8,1.1,2.9,5.6,4.2,8.3c0.2,0.4-0.3,0.8-0.7,0.5c-2.1-2-5.8-5.5-6.5-6.6c-0.6-0.8-0.4-2,0.4-2.6 C41.6,20.2,42.8,20.4,43.4,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.1,21.3c-0.8,1.1-2.9,5.6-4.2,8.3c-0.2,0.4,0.3,0.8,0.7,0.5c2.1-2,5.8-5.5,6.5-6.6c0.6-0.8,0.4-2-0.4-2.6 C75.9,20.2,74.7,20.4,74.1,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.2,52.4c-1.3-0.4-6.3-1-9.2-1.4c-0.5-0.1-0.7,0.6-0.3,0.8c2.6,1.4,7,3.8,8.3,4.2c1,0.3,2-0.2,2.4-1.2 C87.7,53.8,87.2,52.8,86.2,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,52.4c1.2-0.4,6.3-1.1,9.2-1.4c0.5-0.1,0.7,0.6,0.3,0.8c-2.6,1.4-7,3.8-8.3,4.2c-1,0.3-2-0.2-2.4-1.2 C29.8,53.8,30.3,52.8,31.3,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.9,73.6c0-1.3,0.9-6.3,1.5-9.2c0.1-0.5,0.7-0.5,0.8,0c0.6,2.9,1.5,7.8,1.5,9.2c0,1-0.8,1.9-1.9,1.9 C57.8,75.5,56.9,74.7,56.9,73.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62,26.8l-2.2-5c-0.4-1-1.8-1-2.2,0l-6,13.8l-15,1.4c-1.1,0.1-1.5,1.4-0.7,2.1L47.3,49L44,63.8 c-0.2,1,0.9,1.8,1.8,1.3l1.7-1C50.3,45.7,58.3,32.3,62,26.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelNewFlash);
export default __webpack_public_path__ + "static/media/label-new-flash.444f3560b7d062547694349beb755bea.svg";
export { ForwardRef as ReactComponent };